import React from 'react';
import { Card, Row, Col, Statistic, Divider, Progress } from 'antd';
import { UserOutlined, ClockCircleOutlined, ShoppingOutlined } from '@ant-design/icons';

const CustomerMetricsCard = ({ data }) => {
  // Handle case when data is not available
  if (!data) {
    return (
      <Card title="Customer Metrics" className="dashboard-card">
        <div className="card-content">
          <p>No customer data available</p>
        </div>
      </Card>
    );
  }

  // Calculate percentages for display
  const recentPercentage = data.totalUniqueCustomers > 0 
    ? Math.round((data.recentCustomers / data.totalUniqueCustomers) * 100) 
    : 0;
  
  const monoBuyerPercentage = data.totalUniqueCustomers > 0 
    ? Math.round((data.monoBuyers / data.totalUniqueCustomers) * 100) 
    : 0;
  
  const multiBuyerPercentage = data.totalUniqueCustomers > 0 
    ? Math.round((data.multiBuyers / data.totalUniqueCustomers) * 100) 
    : 0;

  return (
    <Card 
      title={
        <div className="card-title">
          <UserOutlined /> Customer Metrics
        </div>
      } 
      className="dashboard-card"
    >
      <div className="card-content">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Statistic 
              title="Total Unique Customers" 
              value={data.totalUniqueCustomers} 
              valueStyle={{ color: '#1890ff', fontSize: '24px' }}
            />
          </Col>
        </Row>
        <Divider style={{ margin: '12px 0' }} />
        
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="metric-section">
              <h4><ShoppingOutlined /> Buyer Type</h4>
              <Row gutter={[16, 8]}>
                <Col span={12}>
                  <Statistic 
                    title="Mono Buyers" 
                    value={data.monoBuyers} 
                    valueStyle={{ fontSize: '16px', color: '#1890ff' }}
                  />
                  <Progress 
                    percent={monoBuyerPercentage} 
                    strokeColor="#1890ff"
                    size="small"
                  />
                </Col>
                <Col span={12}>
                  <Statistic 
                    title="Multi Buyers" 
                    value={data.multiBuyers} 
                    valueStyle={{ fontSize: '16px', color: '#52c41a' }}
                  />
                  <Progress 
                    percent={multiBuyerPercentage} 
                    strokeColor="#52c41a"
                    size="small"
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Divider style={{ margin: '12px 0' }} />
        
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="metric-section">
              <h4><ClockCircleOutlined /> Recency (1-3 months)</h4>
              <Row align="middle">
                <Col span={12}>
                  <Statistic 
                    value={data.recentCustomers} 
                    suffix={`/ ${data.totalUniqueCustomers}`}
                    valueStyle={{ fontSize: '16px' }}
                  />
                </Col>
                <Col span={12}>
                  <Progress 
                    percent={recentPercentage} 
                    strokeColor="#722ed1"
                    size="small"
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Divider style={{ margin: '12px 0' }} />
        
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="metric-section">
              <h4>Recent Customer Breakdown</h4>
              <Row gutter={[16, 8]}>
                <Col span={12}>
                  <Statistic 
                    title="Recent Mono Buyers" 
                    value={data.recentMonoBuyers} 
                    valueStyle={{ fontSize: '16px', color: '#1890ff' }}
                  />
                </Col>
                <Col span={12}>
                  <Statistic 
                    title="Recent Multi Buyers" 
                    value={data.recentMultiBuyers} 
                    valueStyle={{ fontSize: '16px', color: '#52c41a' }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
       

       
      </div>
    </Card>
  );
};

export default CustomerMetricsCard;
